import React from "react";
import styled from "styled-components";
import "../../fonts/font.css";

import Searching from "../../images/search_icon.png";
import Money from "../../images/money.png";
import Box1 from "../../images/box1.png";
import Possibility from "../../images/possibility.png";

export const StyledBox = styled.div`
  height: ${(props) => props.height || 140}px;
  width: ${(props) => props.width || 230}px;

  background-color: ${(props) => props.color || "#ffffff"};
  background-image: ${(props) => props.backgroundImage || "initial"};
  border: ${(props) => props.borderSize || 0.5}px solid
    ${(props) => props.borderColor || "#cccccc"};
  box-shadow: ${(props) => props.boxShadow};
  box-sizing: content-box;
  border-radius: 10px;

  & + & {
    margin-left: 30px;
  }

  padding: ${(props) => props.padding || 30}px;

  font-weight: ${(props) => props.fontWeight || 300};
  font-size: ${(props) => props.fontSize}px;

  /* &:hover {
    border: 0.5px solid "#000000" !important;
  } */
`;



export const GradientBox = styled.div`
  height: ${(props) => props.height || 170}px;
  width: ${(props) => props.width || 760}px;

  background-image: url(${Box1});

  box-sizing: content-box;
  border-radius: 10px;

  margin-right: 30px;

  padding: 30px 30px 30px 30px;

  font-weight: ${(props) => props.fontWeight || 300};
  font-size: ${(props) => props.fontSize}px;

  /* 
  display: flex;
  flex-direction: column; */
`;

export const PossibilityBox = styled.div`
  height: ${(props) => props.height || 120}px;
  width: ${(props) => props.width || 350}px;

  background-image: url(${Possibility});

  box-sizing: content-box;
  border-radius: 10px;

  padding: 30px 30px 30px 30px;
  border-bottom: ${(props) => props.borderSize || 0.5}px solid
    ${(props) => props.borderColor || "#cccccc"};

  font-weight: ${(props) => props.fontWeight || 300};
  font-size: ${(props) => props.fontSize}px;

  /* 
  display: flex;
  flex-direction: column; */
`;

export const TextWrapper = styled.div`
  display: flex;
  //margin-top: 30px;

  p {
    font-size: 25px;
    color: #ffffff;
    font-family: Sandoll GothicNeo1;
    font-style: normal;
    font-weight: normal;
  }

  span {
    font-size: 50px;
    color: #ffffff;
    font-family: Sandoll GothicNeo1;
    font-style: normal;
    font-weight: bold;
  }
`;

export const CardTitle = styled.div`
  position: relative;

  font-family: Noto Sans KR;
  font-style: normal;
  font-weight: bold;
  font-size: ${(props) => props.fontSize || 24}px;
  line-height: 35px;

  color: ${(props) => props.color || "#333333"};

  margin-bottom: ${(props) => props.marginBottom}px;
  margin-top: ${(props) => props.marginTop}px;
  margin-left: ${(props) => props.marginLeft}px;

  span {
    font-weight: normal;
    font-size: ${(props) => props.sfontSize || 17}px;
  }
`;

export const CardText = styled.div`
  position: relative;

  font-family: Noto Sans KR;
  font-style: normal;
  font-weight: normal;
  font-size: ${(props) => props.fontSize || 17}px;
  line-height: ${(props) => props.lineHeigh || 25}px;

  margin-top: ${(props) => props.marginTop || 10}px;
  margin-bottom: ${(props) => props.marginBottom || 10}px;
  letter-spacing: ${(props) => props.letterSpacing || -0.01}em;

  color: ${(props) => props.color || "#555555"};
`;

export const Input = styled.input`
  width: 230px;
  height: 45px;

  font-size: 15px;
  padding: 15px;
  border: 1px solid #cccccc;
  box-sizing: border-box;
  border-radius: 5px;

  background: ${(props) => props.color || "#ffffff"};

  ::placeholder {
    color: #999999;
  }
`;

export const InputDiv = styled.div`
  width: 230px;
  height: 45px;

  font-size: 15px;
  padding: 10px;
  border: 1px solid #cccccc;
  box-sizing: border-box;
  border-radius: 5px;

  background: #ffffff;

  font-family: Noto Sans KR;
  font-style: normal;
  font-weight: normal;
  line-height: 25px;
  color: #999999;
`;

export const SearchIcon = styled.img`
  width: 20px;
  height: 20px;

  position: relative;
  top: -3px;
  left: 0px;
  margin-right: 10px;
`;
SearchIcon.defaultProps = {
  src: Searching,
};

export const MoneyIcon = styled.img`
  width: 40px;
  height: 40px;

  position: relative;
  top: 0%;
  right: 0%;
`;
MoneyIcon.defaultProps = {
  src: Money,
};

export const Radio = styled.input`
  padding: 15px;
  color: #999999;
  width: 14px;
  height: 14px;
  margin-right: 15px;
`;

export const RadioLabel = styled.label`
  font-family: Noto Sans KR;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 15px;

  color: #333333;
`;

export const Select = styled.select`
  width: 104px;
  height: 45px;

  font-size: 15px;
  color: #999999;
  padding: 10px;
  border: 1px solid #cccccc;
  border-radius: 5px;

  background: #eeeeee;

  margin-right: 5px;
  margin-left: 5px;

  option {
    display: flex;
    white-space: pre;
    background: #ffffff;
    border: 1px solid #cccccc;
  }
`;

export const Caption = styled.div`
  position: relative;
  bottom: 0%;

  float: right;

  font-family: Noto Sans KR;
  font-style: normal;
  font-weight: normal;
  font-size: ${(props) => props.fontSize || 12}px;
  line-height: ${(props) => props.lineHeight || 13}px;

  margin-top: ${(props) => props.marginTop}px;
  margin-bottom: ${(props) => props.marginBottom}px;

  color: ${(props) => props.color || "#555555"};
`;
